
import React, { useState } from 'react';
import { Layout, Typography, Form, Input, Button, Alert, Spin } from 'antd';
import { UserOutlined, LockOutlined, IdcardOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './SuperadminLogin.css';

const { Content, Header } = Layout;
const { Title, Text } = Typography;

const SuperadminLogin = () => {
  const [form] = Form.useForm();
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await fetch('/backend/superadmin_login.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          email: values.email,
          password: values.password,
        }),
      });

      const result = await response.json();

      if (response.ok) {
        setSuccess('Connexion réussie ! Redirection vers le tableau de bord...');
        setError(null);
        setTimeout(() => navigate('/SuperAdminDashboard'), 2000);
      } else {
        setError(result.error || 'Erreur lors de la connexion.');
        setSuccess(null);
      }
    } catch (error) {
      setError('Une erreur s\'est produite lors de la connexion.');
      setSuccess(null);
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <Layout className="auth-layout">
      <Header className="auth-header">
        <div className="logo">
          <IdcardOutlined className="logo-icon" />
          <Title level={4} className="logo-text">
            NH Guide - Superadmin
          </Title>
        </div>
      </Header>
      <Content className="auth-content">
        <div className="auth-container">
          <Title level={2} className="auth-title">
            Connexion Superadmin
          </Title>
          <Text className="auth-subtitle">
            Connectez-vous à votre compte superadmin pour gérer NH Guide.
          </Text>
          {error && (
            <Alert
              message={error}
              type="error"
              showIcon
              className="auth-alert auth-alert-error"
            />
          )}
          {success && (
            <Alert
              message={success}
              type="success"
              showIcon
              className="auth-alert auth-alert-success"
            />
          )}
          <Form
            form={form}
            name="superadminLogin"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            layout="vertical"
            className="auth-form"
          >
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: 'Veuillez entrer votre email !' },
                { type: 'email', message: 'Veuillez entrer un email valide !' },
              ]}
            >
              <Input
                prefix={<UserOutlined className="input-icon" />}
                placeholder="superadmin@example.com"
                size="large"
                className="auth-input"
              />
            </Form.Item>
            <Form.Item
              label="Mot de passe"
              name="password"
              rules={[{ required: true, message: 'Veuillez entrer votre mot de passe !' }]}
            >
              <Input.Password
                prefix={<LockOutlined className="input-icon" />}
                placeholder="Mot de passe"
                size="large"
                className="auth-input"
              />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                block
                className="auth-button"
                disabled={loading}
              >
                {loading ? <Spin size="small" /> : 'Se connecter'}
              </Button>
            </Form.Item>
            <Text className="auth-link-text">
              Pas de compte ?{' '}
              <a onClick={() => navigate('/superadminregister')} className="auth-link">
                S'inscrire
              </a>
            </Text>
          </Form>
        </div>
      </Content>
    </Layout>
  );
};

export default SuperadminLogin;
